import React from 'react';
import TimePicker from 'react-time-picker';
import styles from './styles/styles.module.css';
import 'react-time-picker/dist/TimePicker.css'; // import base styles

interface TimePickerInterface {
  time: string | null;
  setTime: React.Dispatch<React.SetStateAction<string | null>>;
}

const TimePick: React.FC<TimePickerInterface> = ({ time, setTime }) => {
  return (
    <TimePicker
      onChange={setTime}
      value={time}
      disableClock={true}
      format="HH:mm"
      clearIcon={null}
      className={styles.timeInput}
    />
  );
};

export default TimePick;
